import {
	WeaLocaleProvider
} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

export const i18n = {
	module: {
		orgAndAuthCenter: () => getLabel(33635, '组织权限中心'),
		securitySetting: () => getLabel(32496, '安全设置'),
		authorizationSetting: () => getLabel(16526, '权限设置'),
		subCompanyFieldDef: () => getLabel(81876, '分部字段定义'),
		departmentFieldDef: () => getLabel(81877, '部门字段定义'),
		resourceFieldDef: () => getLabel(81878, '人员卡片字段定义'),
		roleSetting: () => getLabel(16527, '角色设置'),
		batchMaintenance: () => getLabel(33923, '批量维护'),
		batchAdjustSubCompany: () => getLabel(385879, '批量调整分部信息'),
		batchAdjustDepartment: () => getLabel(385881, '批量调整部门信息'),
		batchAdjustResource: () => getLabel(385883, '批量调整人员信息'),
		batchEditSubCompany: () => getLabel(385885, '批量编辑分部信息'),
		batchEditDepartment: () => getLabel(385887, '批量编辑部门信息'),
		batchEditResource: () => getLabel(385889, '批量编辑人员信息'),
		batchUploadPhoto: () => getLabel(385891, '批量上传人员照片'),
		batchAdjustSubCompanyTips: () => getLabel(385880, '将多个分部的指定信息调整成统一值'),
		batchAdjustDepartmentTips: () => getLabel(385882, '将多个部门的指定信息调整成统一值'),
		batchAdjustResourceTips: () => getLabel(385884, '将多个人员的指定信息调整成统一值'),
		batchEditSubCompanyTips: () => getLabel(385886, '在一个列表中编辑分部信息，例如批量排序，批量编号'),
		batchEditDepartmentTips: () => getLabel(385888, '在一个列表中编辑部门信息，例如批量排序，批量编号'),
		batchEditResourceTips: () => getLabel(385890, '在一个列表中编辑人员信息，例如批量排序，批量编号'),
		batchUploadPhotoTips: () => getLabel(385892, '批量上传维护人员照片'),
		authAdjust: () => getLabel(34238, '权限调整'),
		matrixAdjust: () => getLabel(383940, '批量调整'),
		authSearch: () => getLabel(81553, '权限查询'),
		appDetach: () => getLabel(33653, '组织机构应用分权'),
		matrixSetting: () => getLabel(33926, '矩阵设置'),
		stateChangeWfSetting: () => getLabel(84790, '状态变更流程'),
		timeManagerWfSetting: () => getLabel(82797, '考勤流程设置'),
		enterLog: () => getLabel(18168, '人员登入日志'),
		basicInfoImport: () => getLabel(125428, '基础数据导入'),
		salaryIndexSetting: () => getLabel(19427, '薪酬指标设置'),
		paidLevelSetting: () => getLabel(82799, '调休设置'),
		paidLevelTimeSetting: () => getLabel(82800, '调休时间查询'),
		onlineAnalysis: () => getLabel(31277, '在线人数分析'), //only chinese
		importExternalDataAttendance: () => getLabel(33539, '考勤外部数据导入'),
		dataSyncSetting: () => getLabel(33740, '数据同步设置'),
		salaryBank: () => getLabel(15812, '工资银行'),
		personalSalaryAdjustment: () => getLabel(33399, '个人工资项调整'),
		workTime: () => getLabel(125799, '工作时段'),
		shiftsSetting: () => getLabel(125800, '班次设置'),
		limitedLoginAnalysis: () => getLabel(31310, '并发登录被限统计'), //only chinese
		salaryIndexMaintenance: () => getLabel(19430, '薪酬指标数据维护'),
		wageSetting: () => getLabel(33397, '工资项设置'),
		trainTypes: () => getLabel(6130, '培训种类'),
		trainPlan: () => getLabel(6128, '培训规划'),
		trainResource: () => getLabel(15879, '培训资源'),
		schedulingSetting: () => getLabel(16695, '排班设置'),
		generalWorkingHours: () => getLabel(16687, '一般工作时间'), //only chinese
		workingDayAdjust: () => getLabel(16750, '工作日期调整'),
		payrollManagement: () => getLabel(33398, '工资单管理'),
		leaveType: () => getLabel(21609, '请假类型设置'),
		annualPeriod: () => getLabel(21598, '年假有效期设置'),
		annualRule: () => getLabel(32758, '年假批量处理规则'),
		annualSetting: () => getLabel(21600, '年假设置'),
		onlineAttendance: () => getLabel(33545, '在线签到考勤'),
		trainArrange: () => getLabel(6156, '培训安排'),
		paidLeavePeriod: () => getLabel(131559, '带薪假有效期设置'),
		paidLeaveRule: () => getLabel(131560, '带薪假批量处理规则'),
		paidLeaveSetting: () => getLabel(131557, '带薪假设置'),
		trainActivity: () => getLabel(6136, '培训活动'),
		attendanceSetting: () => getLabel(128558, '考勤应用设置'),
		orgChart: () => getLabel(16459, '图形编辑'),
		privacySetting: () => getLabel(127406, '隐私设置'),
		rpType: () => getLabel(6099, '奖惩种类'),
		rpManage: () => getLabel(6100, '奖惩管理'),
		contractType: () => getLabel(6158, '合同种类'),
		assType: () => getLabel(6118, '考核种类'),
		assItem: () => getLabel(6117, '考核项目'),
		assImple: () => getLabel(6124, '考核实施'),
		contractExpireWarning: () => getLabel(19149, '合同到期提醒'),
		titleSetting: () => getLabel(16462, '职称设置'),
		signatureManagement: () => getLabel(16627, "签章管理"),
		moduleManagementDecent: () => getLabel(33654, '模块管理分权'),
		dismiss: () => getLabel(16472, '人员解聘'),
		formal: () => getLabel(16466, '人员转正'),
		rehire: () => getLabel(16471, '人员返聘'),
		quit: () => getLabel(16469, '人员离职'),
		renew: () => getLabel(16467, '人员续签'),
		retire: () => getLabel(16470, '人员退休'),
		personTransfer: () => getLabel(16468, '人员调动'),
		trial: () => getLabel(17513, '人员试用'),
		entryMaintenanceSettings: () => getLabel(386202, '入职维护设置'),
		groupSet: () => getLabel(24001, '群组设置'),
		educationSet: () => getLabel(16464, '学历设置'),
		decentAdminSetting: () => getLabel(386203, '分权管理员设置'),
		staffCardDisplay: () => getLabel(33647, '人员卡片显示栏目'),
		birthdayRemind: () => getLabel('391181', "生日提醒"),
		areaSet: () => getLabel(126169, '行政区域设置'),
		managementDecent: () => getLabel(24326, '管理分权'),
		contractMaintain: () => getLabel(33741, '合同维护'),
		contractTemplate: () => getLabel(15786, '合同模板'),
		funcManageDecent: () => getLabel('33651', "功能管理赋权"),
		letStaffFeelWarm: () => getLabel('391180', "员工关怀提醒"),
		employDemand: () => getLabel('6131', "用工需求"),
		recruitPlan: () => getLabel('6132', "招聘计划"),
		recruitInfo: () => getLabel('366', "招聘信息"),
		workNature: () => getLabel('804', "用工性质"),
		unitSetting: () => getLabel(16511, '单位设置'),
		recruitLibrary: () => getLabel(16251, '应聘库'),
		loginFailLog: () => getLabel('391172', "人员登入失败日志")
	},
	label: {
		authorizationGroup: () => getLabel(492, '权限组'),
		allAuthorization: () => getLabel(33363, '全部权限'),
		authorizationGroupInfo: () => getLabel(383045, '权限组信息'),
		authorizationDetail: () => getLabel(383040, '权限明细'),
		selectAuthorization: () => getLabel(383046, '选择权限项'),
		createAuthorizationGroup: () => getLabel(383047, '新建权限组'),
		modifyAuthorizationGroup: () => getLabel(383048, '编辑权限组'),
		byList: () => getLabel(130619, '按列表'),
		byAuthGroup: () => getLabel(382866, '按权限组'),
		basicSetting: () => getLabel(130187, '基本设置'),
		networkStrategy: () => getLabel(21384, '网络策略'),
		advanceSetting: () => getLabel(19332, '高级设置'),
		fieldLabel: () => getLabel(15456, '字段显示名'),
		fieldName: () => getLabel(23241, '数据库字段名'),
		fieldType: () => getLabel(84113, '字段类型'),
		enable: () => getLabel(31676, '启用'),
		required: () => getLabel(18019, '必填'),
		uploadFile: () => getLabel(20798, '上传文件'),
		selectComponent: () => getLabel(383051, '下拉框'),
		groupName: () => getLabel(129927, '分组名称'),
		show: () => getLabel(127791, '显示'),
		organization: () => getLabel(25332, '组织结构'),
		createRole: () => getLabel(383069, '新建角色'),
		modifyRole: () => getLabel(383070, '编辑角色'),
		roleName: () => getLabel(15068, '角色名称'),
		explain: () => getLabel(85, '说明'), //only chinese
		roleInfo: () => getLabel(33401, '角色信息'),
		authInfo: () => getLabel(17864, '功能权限'),
		detachInfo: () => getLabel(17865, '机构权限'),
		memberInfo: () => getLabel(126254, '成员设置'),
		authRole: () => getLabel(23265, '赋权角色：用于向同级管理员分配数据维护权限。'),
		detachRole: () => getLabel(23266, '分权角色：用于向下级管理员分配“分配权限”的权限。'),
		addRoleAuth: () => getLabel(383101, '添加功能权限'),
		editRoleAuth: () => getLabel(383941, '编辑权限级别'),
		addDetachAuth: () => getLabel(383942, '添加机构权限'),
		editDetachAuth: () => getLabel(383943, '编辑操作级别'),
		addMemberAuth: () => getLabel(125217, '添加成员'),
		editMemberAuth: () => getLabel(383944, '编辑成员级别'),
		authList: () => getLabel(440, '权限项'),
		roleLevel: () => getLabel(383032, '权限级别'),
		company: () => getLabel(140, '总部'),
		subcompany: () => getLabel(33553, '分部'),
		department: () => getLabel(126029, '部门'), //only chinese
		all: () => getLabel(82857, '全部'),
		select: () => getLabel(126832, '选择'),
		saveAs: () => getLabel(131623, '另存为'),
		selectObject: () => getLabel(383945, '选择对象'),
		transferObject: () => getLabel(383946, '转移内容'),
		copyObject: () => getLabel(125318, '复制内容'),
		removeObject: () => getLabel(15444, '删除内容'),
		adjustObject: () => getLabel(383947, '调整内容'),
		type: () => getLabel(132033, '类型'),
		selectedCount: () => getLabel(383948, '已选择数量'),
		selectedCount0: () => getLabel(31503, '已选择'),
		totalCount: () => getLabel(383949, '总计数量'),
		authTransferBeginIn: () => getLabel(383950, '从{beginTime}开始'),
		authTransferFinished: () => getLabel(383951, '从{beginTime}开始至{endTime}结束，共用时：{processTime}'),
		transferTarget: () => getLabel(383952, '由{param}{op}'),
		copyTo: () => getLabel(383953, '复制到'),
		transferTo: () => getLabel(129168, '移动到'),
		deleteTarget: () => getLabel(131966, '删除'),
		authTransferTotalCount: () => getLabel(383954, '共计{param}项权限'),
		authTransferDeleteFinished: () => getLabel(34240, '共计{param}项权限删除成功'),
		authTransferCopyFinished: () => getLabel(34033, '共计{param}项权限复制成功'),
		authTransferTransFinished: () => getLabel(33379, '共计{param}项权限转移成功'),
		userDatas: () => getLabel(383955, '的数据'),
		itemCount: () => getLabel(1331, '数量'),
		detail: () => getLabel(17463, '明细'),
		globalSetting: () => getLabel(33174, '全局设置'),
		appDetachList: () => getLabel(128623, '应用分权列表'),
		createAppDetach: () => getLabel(383956, '新建应用分权'),
		editAppDetach: () => getLabel(383957, '编辑应用分权'),
		basicInfo: () => getLabel(1361, '基本信息'),
		target: () => getLabel(106, '对象'),
		viewRange: () => getLabel(34102, '查看范围'),
		addObject: () => getLabel(383958, '添加对象'),
		addRange: () => getLabel(383959, '添加范围'),
		editObject: () => getLabel(383960, '编辑对象'),
		editRange: () => getLabel(383961, '编辑范围'),
		matrixName: () => getLabel(195, '名称'),
		matrixDesc: () => getLabel(433, '描述'),
		createMatrix: () => getLabel(383962, '新建矩阵'),
		modifyMatrix: () => getLabel(383963, '编辑矩阵'),
		matrixMaintenance: () => getLabel(383964, '矩阵维护者'),
		orderId: () => getLabel(15486, '序号'),
		total: () => getLabel(18609, '共'),
		dataSourceCount: () => getLabel(30690, '条数据'),
		screen: () => getLabel(126129, '筛选'),
		screenInfo: () => getLabel(385323, '筛选此列数据'),
		subCompanyInfo: () => getLabel(32816, '分部信息'),
		departmentInfo: () => getLabel(16289, '部门信息'),
		companyInfo: () => getLabel(16455, '组织结构'),
		showCanceledOrg: () => getLabel(384037, '显示封存机构'),
		hideCanceledOrg: () => getLabel(384038, '不显示封存机构'),
		group: () => getLabel(81554, '常用组'),
		resource: () => getLabel(1867, '人员'),
		batchOperateTitle: () => getLabel(384039, '点击切换批量操作'),
		canceled: () => getLabel(22205, '已封存'),
		noFileSelected: () => getLabel(384040, '未选择任何文件'),
		downLoadTemplete: () => getLabel(125333, '选择文件'),
		success: () => getLabel(15242, '成功'),
		fail: () => getLabel(498, '失败'),
		addVirtualOrg: () => getLabel(384043, '新建组织维度'),
		editVirtualOrg: () => getLabel(384044, '编辑组织维度'),
		editCompany: () => getLabel(384045, '编辑总部'),
		addSubCompany: () => getLabel(384046, '新建分部'),
		editSubCompany: () => getLabel(384047, '编辑分部'),
		addDepartment: () => getLabel(125303, '新建部门'),
		editDepartment: () => getLabel(384048, '编辑部门'),
		confirmInfo: () => getLabel(24960, '提示信息'),
		row: () => getLabel(27592, '行'),
		col: () => getLabel(384968, '列'),
		status: () => getLabel(602, '状态'),
		importResourceResultInfo: () => getLabel(384060, '共{rownum}条数据，{succnum}条导入成功！'),
		importResourceResultInfo1: () => getLabel(384061, '共{rownum}条数据，全部导入成功！'),
		childInfoName: () => getLabel(384279, '子信息名称'),
		displayOrder: () => getLabel(129806, '显示顺序'),
		today: () => getLabel(130019, '今天'),
		tswk: () => getLabel(15539, '本周'),
		tsmth: () => getLabel(383428, '本月'),
		tssn: () => getLabel(383465, '本季'),
		tsyr: () => getLabel(130017, '本年'),
		preMonth: () => getLabel(27347, '上个月'),
		preYear: () => getLabel(81716, '上一年'),
		dateRange: () => getLabel(32530, '指定日期范围'),
		importTemplate: () => getLabel(129833, '导入模板'),
		org: () => getLabel(376, '组织'), //only chinese
		orgMaintenance: () => getLabel(33596, '组织维护'),
		divisionAndDepartmentImport: () => getLabel(125432, '分部、部门导入'),
		post: () => getLabel(6086, '岗位'),
		postSetting: () => getLabel(382806, '职务岗位设置'),
		personalization: () => getLabel(18166, '个性化设置'),
		personalData: () => getLabel(125429, '个人数据'),
		administrativeDivision: () => getLabel(126167, '行政区域'),
		adminDivisionSetting: () => getLabel(126169, '行政区域设置'),
		workingPlace: () => getLabel('15712', "办公地点"),
		workingPlaceSetting: () => getLabel(125448, '办公地点设置'),
		major: () => getLabel(803, '专业'),
		majorSetting: () => getLabel(16463, '专业设置'),
		number: () => getLabel('714', "编号"),
		loginName: () => getLabel(16126, '登录名'),
		downloadTemplateFirst: () => getLabel(383083, '请先下载模板'),
		importResult: () => getLabel(82341, '导入结果'),
		newSalaryIndex: () => getLabel(384289, '新建薪酬指标'),
		editSalaryIndex: () => getLabel(384290, '编辑薪酬指标'),
		overdue: () => getLabel(127265, '天后过期'),
		searchCondition: () => getLabel(20331, '查询条件'),
		paidLevelTime: () => getLabel(82845, '调休时间（小时）'),
		promptInformation: () => getLabel(24960, '提示信息'),
		checkEnable: () => getLabel(18624, '是否启用'),
		syncDateRange: () => getLabel(33542, '同步时间范围'),
		customTimeSegment: () => getLabel(31298, '自定义时间段'),
		salaryAdjustment: () => getLabel(33404, '工资项调整'),
		adjustmentHistory: () => getLabel(15817, '调整历史'),
		createStateChangeWf: () => getLabel(384621, '新建状态变更流程'),
		dateRangeCondition: () => getLabel(124799, '日期范围'),
		createWorktime: () => getLabel(384622, '新建工作时段'),
		modifyWorktime: () => getLabel(384623, '编辑工作时段'),
		beforeWork: () => getLabel(125813, '上班前'),
		afterWork: () => getLabel(125814, '下班后'),
		minute: () => getLabel(15049, '分钟'),
		shiftsDetail: () => getLabel(125817, '班次明细'),
		newSalaryBank: () => getLabel(384565, '新建工资银行'),
		editSalaryBank: () => getLabel(384566, '编辑工资银行'),
		newSalaryIndexDatas: () => getLabel(384571, '新建薪酬指标数据'),
		editSalaryIndexDatas: () => getLabel(384572, '编辑薪酬指标数据'),
		downloadExcelTemplate: () => getLabel('391178', "下载Excel模板"),
		templateFile: () => getLabel(19971, '模板文件'),
		downloadExcelFileBeforeImport: () => getLabel(385329, '请下载模板文件，填入数据后导入'),
		salaryIndex: () => getLabel(19454, '薪酬指标'),
		excelFileImport: () => getLabel(18577, 'Excel文件导入'),
		formulaSetting: () => getLabel(384714, '公式设置'),
		newTrainTypes: () => getLabel(384743, '新建培训种类'),
		editTrainTypes: () => getLabel(384745, '编辑培训种类'),
		personScheduling: () => getLabel(125801, '人员排班'),
		dateScheduling: () => getLabel(125802, '时间排班'),
		withScheduling: () => getLabel(385030, '以具体排班为准'),
		schedulingDetail: () => getLabel(125817, '班次明细'),
		schedulingDetailTips: () => getLabel(125822, '点击班次，可查看班次时间段明细。'),
		plsSelectScheduling: () => getLabel(384624, '请选择工作时段：（所选时段不能有重叠）'),
		plsSelectDate: () => getLabel(27938, '请选择日期'),
		schedulingDetail0: () => getLabel(125833, '排班明细'),
		schedulingDetailTips0: () => getLabel(125834, '点击列表行，可查看人员排班时间段明细。'),
		day: () => getLabel(1925, '天'),
		year: () => getLabel(383372, '年'),
		month: () => getLabel(383373, '月'),
		newTrainPlan: () => getLabel(384870, '新建培训规划'),
		editTrainPlan: () => getLabel(384871, '编辑培训规划'),
		test: () => getLabel(6102, '考评'),
		formName: () => getLabel(15451, '表单名称'),
		plsSetFormName: () => getLabel(82091, '请填写表单名称'),
		uploadFileFirst: () => getLabel(384951, '请先上传文件'),
		newTrainResource: () => getLabel(384956, '新建培训资源'),
		editTrainResource: () => getLabel(384957, '编辑培训资源'),
		editStateChangeWf: () => getLabel(385031, '编辑状态变更流程'),
		createStatesSchedule: () => getLabel(385037, '新建考勤流程'),
		editStatesSchedule: () => getLabel(385038, '编辑考勤流程'),
		setSchduleDetail: () => getLabel(125835, '设置排班'),
		multiResouce: () => getLabel(83496, '多人力资源'),
		pathSetting: () => getLabel(16483, '路径设置'),
		payroll: () => getLabel(503, '工资单'),
		plsSelectNeedCancelSchedule: () => getLabel(125950, '请选择需要取消的班次'),
		calendar: () => getLabel(490, '日历'),
		detailList: () => getLabel(491, '清单'),
		createWorkingDay: () => getLabel(385333, '新建工作日期调整'),
		editWorkingDay: () => getLabel(385334, '编辑工作日期调整'),
		publicScope: () => getLabel(6104, '公开范围'),
		pleaseSelectDatas: () => getLabel(385148, '请勾选需要删除的数据！'),
		newPublicScope: () => getLabel(385149, '新建公开范围'),
		createPaidLeavePeriod: () => getLabel(385335, '新建带薪假有效期设置'),
		editPaidLeavePeriod: () => getLabel(385336, '编辑带薪假有效期设置'),
		editPublicScope: () => getLabel(385171, '编辑公开范围'),
		newTrainArrangement: () => getLabel(385173, '新建培训安排'),
		editTrainArrangement: () => getLabel(385174, '编辑培训安排'),
		trainSchedule: () => getLabel(16150, '培训日程'),
		createPaidLeaveRule: () => getLabel(385337, '新建带薪假批量处理规则'),
		editPaidLeaveRule: () => getLabel(385338, '编辑带薪假批量处理规则'),
		paidLeaveYear: () => getLabel(385339, '带薪假年'),
		annualYear: () => getLabel(385340, '年假年份'),
		sent: () => getLabel('19558', "已发送"),
		unsend: () => getLabel(19557, '未发送'),
		createAnnualPeriod: () => getLabel(385341, '新建年假有效期设置'),
		editAnnualPeriod: () => getLabel(385342, '编辑年假有效期设置'),
		createAnnualRule: () => getLabel(385343, '新建年假批量处理规则'),
		editAnnualRule: () => getLabel(385344, '编辑年假批量处理规则'),
		noOver: () => getLabel(24324, '未结束'),
		over: () => getLabel(383417, '已结束'),
		unaccomplish: () => getLabel(385345, '暂未实现！'),
		showAllType: () => getLabel(385346, '显示全部类型'),
		newWorkHour: () => getLabel(385347, '新建一般工作时间'),
		editWorkHour: () => getLabel(385348, '编辑一般工作时间'),
		pleaseSelectTime: () => getLabel(385349, '请选择引用的工作日'),
		selectQuotingSet: () => getLabel(32760, '引用设置'),
		monday: () => getLabel(392, '星期一'),
		tuesday: () => getLabel(393, '星期二'),
		wednesday: () => getLabel(394, '星期三'),
		thursday: () => getLabel(395, '星期四'),
		friday: () => getLabel(396, '星期五'),
		saturday: () => getLabel(397, '星期六'),
		sunday: () => getLabel(398, '星期日'),
		onlineAttendanceSet: () => getLabel(34169, '在线签到考勤设置'),
		workTimeSet: () => getLabel(385350, '工作时间设置'),
		nolimited: () => getLabel(32499, '不限制'),
		halfday: () => getLabel(128559, '半天'),
		allday: () => getLabel(27641, '全天'),
		minUnit: () => getLabel(385351, '最小单位'),
		defaultTime: () => getLabel(385352, '默认时间'),
		illustration: () => getLabel(25734, '说明'),
		daytime: () => getLabel(390, '日'),
		am: () => getLabel(16689, '上午'),
		pm: () => getLabel(16690, '下午'),
		attendanceRulesSetting: () => getLabel(385353, '考勤规则设置'),
		trainTest: () => getLabel(16143, '培训考核'),
		trainReview: () => getLabel(16144, '培训考评'),
		attendCircumstances: () => getLabel(33430, '参加情况'),
		addTrainActivity: () => getLabel(385927, '新增培训活动'),
		editTrainActivity: () => getLabel(385928, '编辑培训活动'),
		addTrainee: () => getLabel(16148, '增加培训人'),
		addTrainSchedule: () => getLabel(16151, '增加培训日程'),
		editTrainSchedule: () => getLabel(385929, '编辑培训日程'),
		stopActivity: () => getLabel(385172, '结束活动'),
		addTestInfo: () => getLabel(385930, '新增培训考核'),
		editTestInfo: () => getLabel(385931, '编辑培训考核'),
		addReviewInfo: () => getLabel(385932, '新增培训考评'),
		editReviewInfo: () => getLabel(385933, '编辑培训考评'),
		finishInfo: () => getLabel(6135, '结束信息'),
		none: () => getLabel(83519, '无'),
		setYear: () => getLabel(385642, '指定年份'),
		newSalaryItemsSet: () => getLabel(385934, '新建工资项设置'),
		editSalaryItemsSet: () => getLabel(385935, '编辑工资项设置'),
		levelSet: () => getLabel(385936, '等级设置'),
		benchmarkSet: () => getLabel(33603, '个人基准设置'),
		customerSetting: () => getLabel(32470, '自定义设置'),
		condition: () => getLabel(15364, '条件'),
		formula: () => getLabel(18125, '公式'),
		remindingCycle: () => getLabel(18711, '提醒周期'),
		useSamePassword: () => getLabel(32500, '同一密码使用'),
		forcedRevision: () => getLabel(385663, '天后强制修改，'),
		preCompulsoryRevision: () => getLabel(32502, '强制修改前'),
		remindingUser: () => getLabel(385664, '天提醒用户'),
		errAccumulative: () => getLabel(32504, '输入密码错误累计'),
		lockAccount: () => getLabel(385665, '次锁定账号，'),
		locking: () => getLabel(16213, '锁定'),
		unlockingInMinutes: () => getLabel(385666, '分钟后自动解锁'),
		preview: () => getLabel(221, '预览'),
		beforeActive: () => getLabel(385667, '启用此功能必须先'),
		setNetworkStrategy: () => getLabel(385668, '设置网段策略'),
		leaveStaffHelper: () => getLabel(385669, '启用后，只有有"离职人员查看"权限的用户可以检索非在职人员'),
		syncDynamicPasswordHelper: () => getLabel(83874, '同步默认方式到所有使用动态密码的人'),
		syncDynamicTokenHelper: () => getLabel(385672, '同步默认方式到所有使用动态令牌的人'),
		syncHTKeyHelper: () => getLabel(385673, '同步默认方式到所有使用海泰key的人'),
		syncCAHelper: () => getLabel(388512, '同步默认方式到所有使用CA验证的人'),
		startIPAddress: () => getLabel(21387, '起始IP地址'),
		endIPAddress: () => getLabel(385675, '结束IP地址'),
		createNetworkStrategy: () => getLabel(385676, '新建网段策略'),
		editNetworkStrategy: () => getLabel(385679, '编辑网段策略'),
		unfilled: () => getLabel(21423, '未填写'),
		addConditionField: () => getLabel(385683, '此区域用于添加条件字段'),
		addValField: () => getLabel(385684, '此区域用于添加取值字段'),
		taxRateSet: () => getLabel(17226, '税率设置'),
		newRpType: () => getLabel(385937, '新建奖惩种类'),
		editRpType: () => getLabel(385938, '编辑奖惩种类'),
		newRpManage: () => getLabel(385939, '新建奖惩管理'),
		editRpManage: () => getLabel(385940, '编辑奖惩管理'),
		personalPercent: () => getLabel(385941, '个人百分比'),
		companyPercent: () => getLabel(385942, '公司百分比'),
		newContractType: () => getLabel(385943, '新建合同种类'),
		editContractType: () => getLabel(385944, '编辑合同种类'),
		newAssType: () => getLabel(385945, '新建考核种类'),
		editAssType: () => getLabel(385946, '编辑考核种类'),
		assDoc: () => getLabel(15759, '考核资料'),
		assItem: () => getLabel(6117, '考核项目'),
		assedPost: () => getLabel(17425, '被考核岗位'), //only chinese
		weight: () => getLabel(6071, '权重'),
		assPerson: () => getLabel(15662, '考核人'),
		oneself: () => getLabel(15763, '本人'),
		directSuperior: () => getLabel(15709, '直接上级'),
		allSuperiors: () => getLabel(15762, '所有上级'),
		directSubordinates: () => getLabel(15764, '直接下级'),
		allLowerLevels: () => getLabel(15765, '所有下级'),
		anotherDeptPerson: () => getLabel(15766, '本部门其他人'),
		humanResource: () => getLabel(179, '人力资源'),
		createWorkflow: () => getLabel(127037, '创建流程路径'),
		createForm: () => getLabel(127027, '创建表单'),
		newAssItem: () => getLabel(385947, '新建考核项目'),
		editAssItem: () => getLabel(385948, '编辑考核项目'),
		addWarningObject: () => getLabel(385949, '添加提醒对象'),
		batchAdjust: () => getLabel(383940, '批量调整'),
		batchEdit: () => getLabel(383518, '批量编辑'),
		batchUpload: () => getLabel(21400, '批量上传'),
		scheduleMember: () => getLabel(125839, '排班人员'),
		curAss: () => getLabel(15652, '当前考核'),
		completedAss: () => getLabel(15656, '已完成考核'),
		assSituation: () => getLabel(15920, '考核情况'),
		assDetail: () => getLabel(386205, '考核明细'),
		authedSub: () => getLabel(83500, '分权多分部'),
		authedDepart: () => getLabel(21482, '分权多部门'),
		authedHrm: () => getLabel(21480, '分权多人力资源'),
		personalSet: () => getLabel(17627, '个人设置'),
		companySet: () => getLabel(83482, '公司设置'),
		scope: () => getLabel(19467, '范围'),
		timeScope: () => getLabel(19482, '时间范围'),
		_year: () => getLabel(17138, '年度'),
		halfYear: () => getLabel(19483, '半年度'),
		quarter: () => getLabel(17495, '季度'),
		monthly: () => getLabel(19398, '月度'),
		job: () => getLabel(1915, '职务'),
		levelFrom: () => getLabel(386206, '职级(从)'),
		levelTo: () => getLabel(386207, '职级(到)'),
		money: () => getLabel(26877, '金额'),
		city: () => getLabel(493, '城市'),
		taxBase: () => getLabel(15835, '税收基数'),
		series: () => getLabel(386208, '级数'),
		taxLevelFrom: () => getLabel(15837, '含税级距(从)'),
		taxLevelTo: () => getLabel(15838, '含税级距(到)'),
		taxRate: () => getLabel('391179', "税率(%)"),
		quickCalDeduction: () => getLabel(19756, '速算扣除数'),
		newTitle: () => getLabel(386209, '新建职称'),
		editTitle: () => getLabel(386210, '编辑职称'),
		supportFormatPic: () => getLabel(386211, '支持 jpg、png、gif 格式的图片文件'),
		batchAdjustSupSubCompany: () => getLabel(386069, '批量调整上级分部'),
		batchAdjustSubCompany: () => getLabel(386070, '批量调整分部'),
		batchAdjustSupDepartment: () => getLabel(386071, '批量调整上级部门'),
		batchAdjustSup: () => getLabel(386072, '批量调整上级'),
		batchAdjustStation: () => getLabel(386073, '批量调整岗位'),
		batchAdjustDepartment: () => getLabel(386074, '批量调整部门'),
		batchAdjustAccount: () => getLabel(386075, '批量调整主次账号'),
		joinGroup: () => getLabel(130759, '加入到组'),
		batchAdjustPassword: () => getLabel(386120, '批量修改密码'),
		newJobType: () => getLabel(386212, '新建职务类别'),
		newJob: () => getLabel(386213, '新建职务'),
		newPost: () => getLabel(125302, '新建岗位'),
		editJobType: () => getLabel(386214, '编辑职务类别'),
		editJob: () => getLabel(386215, '编辑职务'),
		editPost: () => getLabel(386216, '编辑岗位'),
		typeInfo: () => getLabel(32655, '类别信息'),
		subordinatePosition: () => getLabel(386217, '下级职务'),
		jobInfo: () => getLabel(383211, '职务信息'),
		lowerPost: () => getLabel(386218, '下级岗位'),
		postSys: () => getLabel(82664, '岗位体系'),
		manageableModule: () => getLabel(386219, '可管理模块'),
		onlySelectedAdmin: () => getLabel(386220, '仅分配勾选模块的分权权限。'),
		decentralizationLink: () => getLabel(386221, '管理分权设置链接如下：'),
		decentralizationSet: () => getLabel(386222, '管理分权设置'),
		newMajor: () => getLabel(386223, '新建专业'),
		editMajor: () => getLabel(386224, '编辑专业'),
		untreatedMatters: () => getLabel(386225, '未处理事宜'),
		format: () => getLabel(386226, '格式：'),
		defalutSignTime: () => getLabel(32541, '不填写默认为所有时间都可签到'),
		workingTime: () => getLabel(386227, '工作时间总计：'),
		groupMember: () => getLabel(386228, '群组人员'),
		newEducation: () => getLabel(386229, '新建学历'),
		editEducation: () => getLabel(386230, '编辑学历'),
		sysShowItems: () => getLabel(32980, '系统显示栏目'),
		defineShowItems: () => getLabel(32744, '自定义显示栏目'),
		childItems: () => getLabel(32749, '子栏目'),
		sysadminRemind: () => getLabel(386231, '管理员提醒'),
		staffRemind: () => getLabel(386232, '员工提醒'),
		css: () => getLabel(1014, '样式'),
		pictureSet: () => getLabel(22923, '图片设置'),
		maxSize: () => getLabel(386233, '最大 10M/个（建议尺寸：475*500）'),
		adviceSize: () => getLabel('386989', "最大 10M/个（建议尺寸：700*330）"),
		sysAdmin: () => getLabel(16139, '系统管理员'),
		date: () => getLabel(22823, '日期'),
		newCountry: () => getLabel(386234, '新建国家'),
		newProvince: () => getLabel(386235, '编辑省份'),
		newCity: () => getLabel(386236, '编辑城市'),
		newCityTwo: () => getLabel(386237, '编辑区县'),
		editCountry: () => getLabel(386238, '编辑国家'),
		editProvince: () => getLabel(386235, '编辑省份'),
		editCity: () => getLabel(386236, '编辑城市'),
		editCityTwo: () => getLabel(386237, '编辑区县'),
		countryInfo: () => getLabel(386239, '国家信息'),
		lowerProvince: () => getLabel(386240, '下级省份'),
		provinceInfo: () => getLabel(386241, '省份信息'),
		lowerCity: () => getLabel(386242, '下级城市'),
		cityInfo: () => getLabel(386243, '城市信息'),
		lowerCityTwo: () => getLabel(386244, '下级区县'),
		areaImportTemplet: () => getLabel(386245, '行政区域导入模板'),
		newWorkPlace: () => getLabel(386246, '新建办公地点'),
		editWorkPlace: () => getLabel(386247, '编辑办公地点'),
		wpImportTemplet: () => getLabel(386248, '办公地点导入模板'),
		newContractMaintain: () => getLabel(386249, '新建合同维护'),
		editContractMaintain: () => getLabel(386250, '编辑合同维护'),
		newContractTemplate: () => getLabel(386251, '新建合同模板'),
		editContractTemplate: () => getLabel(386252, '编辑合同模板'),
		nationalAbbr: () => getLabel(382324, '国家简称'),
		provinceAbbr: () => getLabel(382327, '省份简称'),
		ownedCountry: () => getLabel(125935, '所属国家'),
		province: () => getLabel(800, '省份'),
		cityTwo: () => getLabel(25223, '区县（二级城市）'),
		anniversaryReminding: () => getLabel('391182', "入职周年提醒"),
		newFuncManageDecent: () => getLabel('386990', "新建功能管理赋权"),
		editFuncManageDecent: () => getLabel('386991', "编辑功能管理赋权"),
		maintainerSet: () => getLabel('386992', "维护人设置"),
		decentSet: () => getLabel('33378', "赋权设置"),
		decentSubcompany: () => getLabel('83500', "分权多分部"),
		decentDepartment: () => getLabel('21482', "分权多部门"),
		contractContent: () => getLabel('386993', "合同内容"),
		untreated: () => getLabel('15746', "未处理"),
		recruiting: () => getLabel('15747', "正在招聘"),
		newEmployDemand: () => getLabel('386994', "新建用工需求"),
		editEmployDemand: () => getLabel('386995', "编辑用工需求"),
		newRecruitPlan: () => getLabel('386996', "新建招聘计划"),
		editRecruitPlan: () => getLabel('386997', "编辑招聘计划"),
		stopRecruitPlan: () => getLabel('386998', "结束招聘计划"),
		recruitStep: () => getLabel('15745', "招聘步骤"),
		recruitInfo: () => getLabel('366', "招聘信息"),
		applicationInfo: () => getLabel('386999', "应聘情况"),
		newRecruitInfo: () => getLabel('17153', "新建招聘信息"),
		editRecruitInfo: () => getLabel('387000', "编辑招聘信息"),
		recruitSchedule: () => getLabel('15720', "招聘日程"),
		newSignature: () => getLabel('16387', "新建签章"),
		editSignature: () => getLabel('387001', "编辑签章"),
		signatureImage: () => getLabel('18695', "签章图片"),
		postImportTemplet: () => getLabel(387063, '职务岗位导入模板'),
		majorImportTemplet: () => getLabel(387064, '专业导入模板'),
		newWorkNature: () => getLabel(387065, '新建用工性质'),
		editWorkNature: () => getLabel(387276, '编辑用工性质'),
		addSysadmin: () => getLabel('391183', "添加管理员"),
		newCommonGroup: () => getLabel(387067, '新建群组'),
		editCommonGroup: () => getLabel(33534, '编辑群组'),
		addGroupMember: () => getLabel(387068, '添加群组人员'),
		newUnit: () => getLabel(387069, '新建单位'),
		editUnit: () => getLabel(387178, '编辑单位'),
		toBeTreated: () => getLabel(16349, '待处理'),
		stayBy: () => getLabel(15689, '备用'),
		adjustTarget: () => getLabel('387024', "调整对象"),
		adjustResult: () => getLabel('387025', "共调整 {param1} 个{param2}的 {param3} 个信息项！"),
		noPhoto: () => getLabel('387051', "无照片"),
		hasPhoto: () => getLabel('387052', "有照片"),
		historyUploadRecord: () => getLabel('387056', "历史上传记录"),
		viewUploadLogs: () => getLabel('387057', "查看上传日志"),
		uploadLogs: () => getLabel('387058', "上传日志"),
		categoryAbbreviation: () => getLabel(382407, "类别简称"),
		jobCategory: () => getLabel(805, "职务类别"),
		jobAbbreviation: () => getLabel(382410, "职务简称"),
		duties: () => getLabel(15855, "所属职务"),
		postAbbreviation: () => getLabel(382413, "岗位简称"),
		viewRefs: () => getLabel('33364', "查看引用"),
		view: () => getLabel('33564', "查看"),
		addRoleRefs: () => getLabel('387114', "添加角色引用"),
		multiDeleteRefs: () => getLabel('387113', "批量删除引用"),
		newSysadmin: () => getLabel(387059, '新建管理员'),
		editSysadmin: () => getLabel(387060, '编辑管理员'),
		newModuleDecent: () => getLabel(387061, '新建模块管理分权'),
		editModuleDecent: () => getLabel(387062, '编辑模块管理分权'),
		includeChildren: () => getLabel('128725', "包含下级"),
		notIncludeChildren: () => getLabel('387277', "不包含下级"),
		haveNotDepartment: () => getLabel('387278', "您选择的分部下无部门信息，请重新选择！"),
		haveNotPerson: () => getLabel('387279', "您选择的部门下无人员信息，请重新选择！"),
		adminSet: () => getLabel(17869, '管理员设置'),
		tips: () => getLabel('558', "提示"),
		dbEncryption: () => getLabel('387371', "数据库加密"),
		createAndMoveGroup: () => getLabel('31194', "新建分组并移动"),
	},
	button: {
		collect: () => getLabel(28111, '收藏'),
		helper: () => getLabel(275, '帮助'),
		search: () => getLabel(82529, '搜索'),
		reset: () => getLabel(27088, '重置'),
		ok: () => getLabel(33703, '确定'),
		cancel: () => getLabel(32694, '取消'),
		create: () => getLabel(365, '新建'),
		remove: () => getLabel(20230, '移除'),
		delete: () => getLabel(131966, '删除'),
		modify: () => getLabel(93, '编辑'),
		transfer: () => getLabel(80, '转移'),
		multiRemove: () => getLabel(383696, '批量移除'),
		multiDelete: () => getLabel(32136, '批量删除'),
		save: () => getLabel(30986, '保存'),
		saveAndSetting: () => getLabel(32159, '保存并进入详细设置'),
		more: () => `${getLabel(131654, '更多')}>>`,
		createGroup: () => getLabel(30131, '新建分组'),
		editGroup: () => getLabel(83149, '编辑分组'),
		groupMaintain: () => getLabel(383049, '分组维护'),
		createChildInfo: () => getLabel(17550, '新建子信息'),
		childInfoMaintain: () => getLabel(384280, '子信息维护'),
		editChildInfo: () => getLabel(32732, '编辑子信息'),
		add: () => getLabel(131201, '添加'),
		copy: () => getLabel(77, '复制'),
		log: () => getLabel(83, '日志'),
		replace: () => getLabel(84563, '替换'),
		columnVisibleSetting: () => getLabel(32535, '显示列定制'),
		multiModify: () => getLabel(383518, '批量编辑'),
		multiModifyAuthRoleLevel: () => getLabel(383965, '批量编辑权限级别'),
		multiModifyDetachRoleLevel: () => getLabel(383966, '批量编辑操作级别'),
		multiModifyMemberRoleLevel: () => getLabel(383967, '批量编辑成员级别'),
		removeRef: () => getLabel(33462, '删除引用'),
		doExcute: () => getLabel(83073, '开始执行'),
		done: () => getLabel(555, '完成'),
		selectAll: () => getLabel(383968, '选择全部'),
		selectAll0: () => getLabel(556, '全选'),
		stop: () => getLabel(17581, '停止'),
		goBack: () => getLabel(1290, '返回'),
		maintenancer: () => getLabel(19909, '维护者'),
		fieldMaintenance: () => getLabel(33943, '字段维护'),
		dataMaintenance: () => getLabel(33933, '数据维护'),
		toDataMaintenance: () => getLabel(383969, '保存并进入数据维护'),
		import: () => getLabel(18596, '导入'),
		export: () => getLabel(28343, '导出Excel'),
		clearScreen: () => getLabel(383970, '清空筛选'),
		importResource: () => getLabel(17887, '人员导入'),
		importOrg: () => getLabel(125523, '组织结构导入'),
		resourceAddToVirtual: () => getLabel(34100, '加入到多维组织'),
		setManager: () => getLabel(34078, '设置上级'),
		selectFile: () => getLabel(125333, '选择文件'),
		submit: () => getLabel(615, '提交'),
		importHistoryQuery: () => getLabel(24644, '历史导入记录'),
		queryImportLog: () => getLabel(384041, '查看导入日志'),
		getImportLog: () => getLabel(24835, '导入日志'),
		postSystemImport: () => getLabel(125443, '岗位体系导入'),
		groupInfoImport: () => getLabel(125445, '常用组信息导入'),
		personalAndWorkInfoImport: () => getLabel(125678, '个人信息、工作信息明细内容导入'), //only chinese
		areaInfoImport: () => getLabel(126168, '行政区域导入'),
		workingPlaceImport: () => getLabel(384176, '办公地点导入'),
		workingPlaceInfoImport: () => getLabel(125447, '办公地点信息导入'),
		majorImport: () => getLabel(384177, '专业导入'),
		majorInfoImport: () => getLabel(125449, '专业信息导入'),
		downloadErrorDatas: () => getLabel(384190, '下载错误数据'),
		downloadAllDatas: () => getLabel(384191, '下载全部数据'),
		syncToSubDept: () => getLabel(21671, '同步下级单位'),
		immediateSync: () => getLabel(33543, '立即同步'),
		autoGenerate: () => getLabel(83444, '自动生成'),
		createScheduling: () => getLabel(125836, '新建排班'),
		multiRemoveScheduling: () => getLabel(385032, '批量取消排班'),
		clearScheudling: () => getLabel(125841, '清除排班'),
		close: () => getLabel(309, '关闭'), //only chinese
		multiOp: () => getLabel(21611, '批量处理'),
		resetSetting: () => getLabel(32761, '清除设置'),
		setAddedDays: () => getLabel(128858, '设置额外年假'),
		setting: () => getLabel(30747, '设置'),
		sync: () => getLabel(18240, '同步'),
		multiSetting: () => getLabel(33511, '批量设置'),
		syncDefault: () => getLabel(385686, '同步默认方式'),
		saveSelectedData: () => getLabel(385789, '保存选中项'),
		batchOp: () => getLabel(31914, '批量操作'),
		importMatrix: () => getLabel('386933', "矩阵导入"),
		synchroDecentModules: () => getLabel(33901, "同步所有分权模块"),
		bind: () => getLabel(-1, "绑定"),
		clickToSet: () => getLabel(-1, "点击设置"),
		moveToGroup: () => getLabel('-81296', "移动到组"),
		testConnect: () => getLabel('383271', "测试连接"),
	},
	confirm: {
		defaultTitle: () => getLabel(131329, '信息确认'),
		removeGroupInfo: () => getLabel(383053, '删除分组，该分组下的字段将显示到“基本信息”分组中，确定要删除吗？'),
		groupNameExist: () => getLabel(130074, '已存在同名分组，请确认'),
		childInfoNameExist: () => getLabel(384281, '已存在同名子信息，请确认'),
		groupNameIsEmpty: () => getLabel(130064, '请填写分组名称'),
		displayOrDBFieldIsEmpty: () => getLabel(383054, '字段显示名或数据库字段名不能为空!'),
		displayOrDBFieldExist: () => getLabel(383055, '已存在同名字段显示名或数据库字段名，请确认！'),
		removeSelected: () => getLabel(385639, '确定要移除选择的记录吗？'),
		deleteSelected: () => getLabel(385625, '确定要删除选择的记录吗？'),
		operationConfirm: () => getLabel(383971, '确定要{param}吗？'),
		selectedEmpty: () => getLabel(84093, '请至少选择一条记录!'),
		displayNameExist: () => getLabel(383972, '显示名重复'),
		fieldNameExist: () => getLabel(383973, '字段名重复'),
		matrixNameExist: () => getLabel(384283, '已存在同名矩阵，请确认'),
		cancelSelected: () => getLabel(384051, '确定要封存选中的记录吗？'),
		doISCancelSelected: () => getLabel(384050, '确定要解封选中的记录吗？'),
		remove: () => getLabel(83449, '确定要移除吗？'),
		delete: () => getLabel(83877, '确定要删除吗？'),
		cancel: () => getLabel(384052, '确定要封存吗？'),
		doISCancel: () => getLabel(384053, '确定要解封吗？'),
		subCompanyCodeExist: () => getLabel(384055, '分部编号重复'),
		departmentCodeExist: () => getLabel(384056, '部门编号重复'),
		workCodeExist: () => getLabel(384057, '人员编号重复'),
		forbidden: () => getLabel(385359, '确定要禁用吗?'),
		active: () => getLabel(385033, '确认要启用吗?'),
		removeConfirm: () => getLabel(83449, '确定要移除吗？'),
		syncToSubDept: () => getLabel(21669, '您确定此设置同步到下级单位吗？此操作将覆盖所有下级单位的设置！'),
		conditionFieldEmpty: () => getLabel(384625, '条件字段不能为空'),
		changeRotationModel: () => getLabel(125925, '切换轮换模式将清空班次明细，是否继续？'),
		checkGenForm: () => getLabel(84793, '将生成{param}表单，是否继续？'),
		informConfirm: () => getLabel(15782, '确定要通知吗？'),
		noModification: () => getLabel(19583, '没有修改项！'),
		salaryAdjustConfirm: () => getLabel(19581, '你确定要调整薪酬设置吗？'),
		payrollClosedConfirm: () => getLabel(20805, '关闭工资单后将无法再编辑和重新生成此月工资单'),
		checkCancelSchedule: () => getLabel(125838, '确定要取消排班吗？'),
		syncPaidLeavePeriod: () => getLabel(21669, '您确定此设置同步到下级单位吗？此操作将覆盖所有下级单位的设置！'),
		syncAnnualPeriod: () => getLabel(21669, '您确定此设置同步到下级单位吗？此操作将覆盖所有下级单位的设置！'),
		payrollSendConfirm: () => getLabel(19586, '你确定要发送工资单吗？'),
		leaveTypeNameExist: () => getLabel(385360, '已存在相同请假类型名称，请确认！'),
		setAddedDays: () => getLabel(385361, '设置额外年假是将上一年度的剩余额外年假更新到本年度的额外年假中，确认进行此操作？'),
		batchHandleWarning: () => getLabel(385952, '批处理将按照该项设置的规则重新设置人力资源工资表, 以前所做的所有改动都将改变,是否继续?'),
		refreshWarning: () => getLabel(385953, '当前页面数据将会丢失，是否继续？'),
		batchDeleteConfirm: () => getLabel(385625, '确定要删除选择的记录吗？'),
		syncPrivacySetting: () => getLabel(385753, '确定将所选字段的默认设置同步到所有人吗？'),
		batchHandleWaring: () => getLabel('387002', "确定要批处理吗？"),
		batchHandleTip: () => getLabel('385952', "批处理将按照该项设置的规则重新设置人力资源工资表, 以前所做的所有改动都将改变,是否继续?"),
		checkAdjust: () => getLabel('387023', "确定要做以下调整吗？"),
		deletePhoto: () => getLabel('387049', "确定要删除照片吗？"),
		multiDeletePhoto: () => getLabel('387050', "确定删除所选人员照片吗？"),
		moveFieldConfirm: () => getLabel('388100', "确定要移动所选择的记录到分组{params}吗？")
	},
	message: {
		authFailed: () => getLabel(2012, '对不起，您暂时没有权限！'),
		actionError: () => getLabel(132200, '操作失败！'),
		opSuccess: () => getLabel(30700, '操作成功'),
		saveSuccess: () => getLabel(83551, '保存成功！'),
		saveFailed: () => getLabel(84544, '保存失败！'),
		removeSuccess: () => getLabel(385950, '移除成功！'),
		deleteSuccess: () => getLabel(83472, '删除成功！'),
		dataEmpty: () => getLabel(82241, '不能为空'),
		serverProcessing: () => getLabel(84041, '服务器正在处理，请稍候...'),
		dataNone: () => getLabel(83553, '暂无数据'),
		recordNotFound: () => getLabel(83781, '没有数据'),
		noMatchingData: () => getLabel(384284, '暂无匹配数据'),
		cancelSuccess: () => getLabel(22155, '封存成功！'),
		doISCancelSuccess: () => getLabel(22156, '解封成功！'),
		serverImportProcessing: () => getLabel(384042, '服务器正在处理数据导入，请稍后……'),
		supSubComError: () => getLabel(22214, '所选上级分部不能为当前分部本身！'),
		supDeptComError: () => getLabel(15773, '上级部门不能为本部门!'),
		selectImportTemplete: () => getLabel(385362, '请选择导入模板!'),
		selectImportTempleteError: () => getLabel(384059, '导入文件存在以下错误，请解决后重新上传！'),
		hardLoading: () => getLabel(384193, '拼命加载中'),
		pleaseUploadFile: () => getLabel(384197, '请上传文件'),
		pleaseConfirmDelRows: () => getLabel(30951, '请选择需要删除的数据!'),
		autoGenerateStateChangeForom: () => getLabel(124924, '根据所选变更流程类型自动生成对应的表单'),
		syncSuccess: () => getLabel(384626, '同步成功'),
		plsSelectScheduling: () => getLabel(385034, '请选择工作时段'),
		plsSelectDate: () => getLabel(27938, '请选择日期'),
		dateRangeError: () => getLabel(385035, '下班时间必须晚于上班时间'),
		plsSelect: () => getLabel(125389, '请先选择'),
		autoGenFormFaild: () => getLabel(83398, '类型表单不支持自动生成，请选择已有表单！'),
		sechduleInfoNone: () => getLabel(125942, '该人员在选择日期范围内没有排班信息！'),
		syncDataNone: () => getLabel(21677, '没有选择要同步的项！'),
		paidLeaveDays: () => getLabel(131712, '带薪假天数必须不小于0！'),
		annualdays: () => getLabel(129356, '年假天数必须不小于0！'),
		mustIntVal: () => getLabel(129033, '值只能为正整数！'),
		addeddays: () => getLabel(385363, '额外年假天数必须不小于0！'),
		leavedays: () => getLabel(385364, '已休年假天数必须不小于0！'),
		basedays: () => getLabel(385365, '年假基数必须不小于0！'),
		expiryLessThanEffective: () => getLabel(129817, '失效日期不能小于生效日期'),
		workingage: () => getLabel(385685, '工龄必须不小于0！'),
		dateConstructError: () => getLabel(385643, '数据格式异常'),
		hrmResourceRequired: () => getLabel(385951, '人力资源浏览框必填'),
		logicWrong: () => getLabel(18098, '条件设置不合逻辑'),
		scopeRequired: () => getLabel(386267, '范围必填！'),
		formulaRequired: () => getLabel(386268, '公式必填！'),
		implementation: () => getLabel(385345, '暂未实现！'),
		plsSelect1: () => getLabel(387022, '请至少选择一个设置项！'),
		plsSelectSubCompany: () => getLabel(82181, '请选择分部'),
		plsSelectDepartment: () => getLabel(386118, '请选择分部、部门'),
		plsSelectResource: () => getLabel(386119, '请选择分部、部门或人员'),
		plsSelectTarget: () => getLabel('387021', "请选择调整对象！"),
		accountTypeDiff: () => getLabel(125528, '选择的记录中同时包含主次两种类型账号，请选择同类型账号！'),
		pwdLen: () => getLabel('20172', "密码长度不能小于"),
		pwdType: () => getLabel('31863', "新密码不符合要求，必须为字母大写、字母小写、数字组合！请重新输入！"),
		pwdType1: () => getLabel('83716', "新密码不符合要求，必须为字母、数字、特殊字符组合！请重新输入！"),
		dataConstructError: () => getLabel(385643, '数据格式异常'),
		pleaseAtLeastSelectOne: () => getLabel(387070, '请至少勾选一项可管理模块！'),
		requiredInfoIsNotFull: () => getLabel(387071, '第{param}行必填信息不完整！'),
		startTimeIsAlone: () => getLabel(16696, '开始时间和结束时间没有成对出现！'),
		startTimeMustGreater: () => getLabel(387072, '结束时间需要大于开始时间！'),
		afternoonStartTimeShouldBeLater: () => getLabel(387073, '下午开始时间需要晚于上午结束时间！'),
		secondSignTip: () => getLabel(82927, '第2次签到开始时间只能在上午结束时间与下午开始时间之内！'),
		effectiveDateRequired: () => getLabel(387074, '生效日必填'),
		openThenShowSignInSignOut: () => getLabel(387416, '开启后前端界面会出现【签到】、【签退】按钮'),
		codeTip: () => getLabel(387165, '注意：代码只能为英文字母和阿拉伯数字，英文字母大小写敏感！'),
		noVerifyMethod: () => getLabel(-1, '没有可用的校验方式？'),
		doubleCheckPwdFaild: () => getLabel(81608, '密码验证不通过，请重新输入！'),
		moveSuccess: () => getLabel('129196', "移动成功"),
		'390218': () => getLabel('390218', "请输入正确的手机号码"),
		'24570': () => getLabel('24570', "邮箱地址的格式不正确"),
	},
	smallType: {
		HRM_ENGINE_SECURITYSETTING: 1001, //安全设置
		HRM_ENGINE_ORGANIZATION: 1002, //组织机构
		HRM_ENGINE_ORGANIZATION_COMPANY: 1003, //总部
		HRM_ENGINE_ORGANIZATION_VIRTUAL: 1006, //虚拟维度
		HRM_ENGINE_ORGANIZATION_SUBCOMPANY: 1004, //分部
		HRM_ENGINE_ORGANIZATION_DPEARTMENT: 1005, //部门
		HRM_ENGINE_ORGANIZATION_RESOURCE: 2, //人力资源
		HRM_ENGINE_ORGANIZATION_VIRTUAL_RESOURCE: 1010, //虚拟人力资源
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/public/i18nbk.js